import { Helmet } from "react-helmet-async";

const SEO = ({
    title = "pujaguru - Online Puja Booking | Chadhava | Rituals & Blessings",
    description = "Explore sacred pujas and book your slot effortlessly—online Chadhava, rituals, and blessings, all in one place. Book pujas, chadhava, and get divine blessings from renowned temples.",
    keywords = "puja booking, online puja, chadhava booking, hindu rituals, temple puja, puja guru, book puja online, religious services, spiritual services, puja services india",
    image = "/logoP.png",
    url = "https://staging.pujaguru.org",
    type = "website",
    author = "pujaguru",
    publishedTime = null,
    modifiedTime = null,
    structuredData = null,
    canonical = null,
    noindex = false,
    nofollow = false,
    locale = "en_US",
    alternateLocales = [],
}) => {
    const fullTitle = title.includes("pujaguru")
        ? title
        : `${title} | pujaguru`;
    const canonicalUrl = canonical || url;
    const robotsContent = [
        noindex ? "noindex" : "index",
        nofollow ? "nofollow" : "follow",
    ].join(", ");

    // Default structured data for Organization
    const defaultStructuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "pujaguru",
        url: "https://staging.pujaguru.org",
        logo: "/logoP.png",
        description:
            "Online platform for booking pujas, chadhava, and religious services",
        sameAs: [
            // Add social media links if available
        ],
        contactPoint: {
            "@type": "ContactPoint",
            contactType: "Customer Service",
            availableLanguage: [
                "English",
                "Hindi",
                "Gujarati",
                "Marathi",
                "Tamil",
                "Telugu",
                "Bengali",
            ],
        },
    };

    const finalStructuredData = structuredData || defaultStructuredData;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="title" content={fullTitle} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content={author} />
            <meta name="robots" content={robotsContent} />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />
            <meta name="rating" content="general" />
            <meta name="distribution" content="global" />
            <meta name="coverage" content="worldwide" />
            <meta name="target" content="all" />
            <meta name="audience" content="all" />
            <meta name="copyright" content="pujaguru" />
            <meta name="application-name" content="pujaguru" />
            <meta name="apple-mobile-web-app-title" content="pujaguru" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="mobile-web-app-capable" content="yes" />

            {/* Canonical URL */}
            <link rel="canonical" href={canonicalUrl} />

            {/* Language Alternates */}
            {alternateLocales.map((locale) => (
                <link
                    key={locale.hrefLang}
                    rel="alternate"
                    hrefLang={locale.hrefLang}
                    href={locale.href}
                />
            ))}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:image:secure_url" content={image} />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={fullTitle} />
            <meta property="og:locale" content={locale} />
            <meta property="og:site_name" content="pujaguru" />
            {publishedTime && (
                <meta property="article:published_time" content={publishedTime} />
            )}
            {modifiedTime && (
                <meta property="article:modified_time" content={modifiedTime} />
            )}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:image:alt" content={fullTitle} />
            <meta name="twitter:creator" content="@pujaguru" />
            <meta name="twitter:site" content="@pujaguru" />

            {/* Structured Data (JSON-LD) */}
            {finalStructuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(finalStructuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
